import { useQuery, useMutation } from "react-query";
import {
	getEmailById_api,
	getEmails_api,
	getEmailVariablesById_api,
	updateEmailById_api,
} from "../services/emailTemplates";

export const useGetEmails = (payload) =>
	useQuery(["getEmails", payload], () => getEmails_api(payload));

export const useGetEmailById = (payload) =>
	useQuery(["getEmailById", payload], () => getEmailById_api(payload));

export const useGetEmailVariablesById = (payload) =>
	useQuery(["getEmailVariablesById", payload], () =>
		getEmailVariablesById_api(payload)
	);

export const useUpdateEmailById = () =>
	useMutation("updateEmailById", (body) => updateEmailById_api(body));
